"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WorkerResponse = void 0;
var helpers_1 = require("../../helpers");
var types_1 = require("../../types");
var WorkerResponse = /** @class */ (function () {
    function WorkerResponse(worker, request) {
        var _this = this;
        this.worker = null;
        this.request = null;
        this.params = {};
        this.addResponseListener = function () {
            if (_this.worker) {
                _this.worker.onmessage = function (evt) {
                    var _a = evt.data, type = _a.type, payload = _a.payload;
                    if (type === types_1.WorkerResponseName.GetChecksum) {
                        return _this.getCheckSum(payload);
                    }
                };
            }
        };
        this.putParameter = function (name, value) {
            _this.params[name] = value;
        };
        this.watch = function () {
            _this.addResponseListener();
        };
        this.getCheckSum = function (payload) {
            var _a;
            var id = payload.id, events = payload.events, visitor_id = payload.visitor_id, address = payload.address;
            var salt = (_a = _this.params['salt']) !== null && _a !== void 0 ? _a : 'Pegaxy';
            var checksum = (0, helpers_1.createChecksum)(events, {
                visitor_id: visitor_id,
                address: address,
                salt: salt,
            });
            _this.request.onGetChecksum({
                id: id,
                checksum: checksum,
            });
        };
        this.worker = worker;
        this.request = request;
    }
    return WorkerResponse;
}());
exports.WorkerResponse = WorkerResponse;
